module.exports = __webpack_public_path__ + "img/floder_icon.b24279a5.png";